import type figlet from 'figlet'

export interface FontGeneratorWidgetProps {
  fontSize: number
  filterCategory: FontGeneratorCategories
  text: string
}

export interface FontGeneratorWidgetItemProps {
  fontSize: number
  title: string
  styledText: string
  containerHeight?: string
  asciiFont?: figlet.Fonts
}

export interface FontGeneratorData {
  name: string
  lower: string[]
  upper: string[]
  digits: string[]
  categories: FontGeneratorCategories[]
  prefix: string
  suffix: string
  id: string
}

export enum FontGeneratorCategories {
  FONT_GENERATOR = 1,
  CURSIVE = 2,
  FACEBOOK = 3,
  GREEK = 4,
  GLITCH = 5,
  ITALICS = 6,
  BIG = 7,
  CALLIGRAPHY = 8,
  SMALL = 9,
  WINGDINGS = 10,
  STYLE = 11,
  ASCII = 12,
  CURSED = 13,
  UPSIDE = 14,
  TYPEWRITER = 15,
  UNDERLINE = 16,
  BOLD = 17,
  GOTHIC = 18,
  SPECIAL = 19,
  TIKTOK = 20,
  ZALGO = 21,
  AESTHETIC = 22,
  VAPORWARE = 23,
  SCARY = 24,
  INSTAGRAM = 25,
  TWITTER = 26,
  MIRROR = 27,
  NUMBER = 28,
  COOL = 29,
  DISCORD = 30,
  HACKED = 31,
  WIDE = 32,
  CREEPY = 33,
  CROSS = 34,
  BUBBLE = 35,
  BLOCK = 36,
  FUTURISTIC = 37,
  WEBDINGS = 38,
  CURVE = 39,
}
